'use strict';

/**
 *
 * @name: blackFrame
 *
 */

import DirectiveTemplate from './nn-black-frame.directive.html';

function BlackFrameDirective($sce) {

  'ngInject';

  return {
    replace: true,
    template: DirectiveTemplate,
    link: function(scope, element, attributes) {

      var src = attributes.frameSrc;
      scope.src = $sce.trustAsResourceUrl(src);

      // Fixes irregular nytimes frame
      if (src.indexOf('nyt.com') > -1) {

        var NY_CLASS = 'ny-times-video';
        var _body = $('body');

        _body.addClass(NY_CLASS);
        scope.$on('$destroy', function() {

          _body.removeClass(NY_CLASS);
        });
      }
    }
  };
}

export default BlackFrameDirective;



// WEBPACK FOOTER //
// ./app/components/nn-players/nn-black-frame/nn-black-frame.directive.js